import { Component } from '@angular/core';

@Component({
  template: `
    <div class="page-footer-inner">
      2016 &copy; P2 Energy Solutions
    </div>
  `
})
export class PuiDefaultFooterComponent {}
